@use "../../styles/Colors.scss" as Colors;
@use "../../styles/Constants.scss" as Constants;

.materialRateSource {
	color: Colors.$col-white;
	display: inline-block;
	font-size: Constants.$val-fontSizeXSmall;
	line-height: Constants.$val-spacing-m;
	text-align: center;
	width: Constants.$val-spacing-m;
	border-radius: Constants.$val-borderRadius;
	font-weight: bold;
	user-select: none;

	&.COMPANY_MATERIAL {
		background-color: Colors.$col-design-blue400;
	}

	&.COMPANY {
		background-color: Colors.$col-green;
	}

	&.JOB {
		background-color: Colors.$col-design-orange500;
	}

	&.JOB_MATERIAL {
		background-color: Colors.$color-bronze;
		font-size: Constants.$val-fontSizeXXSmall;
	}


}
